import type React from 'react'

const FileIconWord: React.FC = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0625 5.875V1.625H5.21875C4.32227 1.625 3.625 2.35547 3.625 3.21875V17.0312C3.625 17.9277 4.32227 18.625 5.21875 18.625H14.7812C15.6445 18.625 16.375 17.9277 16.375 17.0312V6.9375H12.125C11.5273 6.9375 11.0625 6.47266 11.0625 5.875ZM12.9551 9.59375H13.7188C13.9844 9.59375 14.1836 9.85938 14.1172 10.0918L12.7227 16.2012C12.6562 16.4004 12.5234 16.5 12.3242 16.5H11.3613C11.1621 16.5 11.0293 16.4004 10.9629 16.2344L10 12.582L9.00391 16.2012C8.9375 16.4004 8.80469 16.5 8.60547 16.5H7.64258C7.44336 16.5 7.31055 16.4004 7.24414 16.2012L5.84961 10.0918C5.7832 9.85938 5.98242 9.59375 6.24805 9.59375H7.01172C7.21094 9.59375 7.34375 9.72656 7.41016 9.92578L8.17383 13.3125L9.10352 9.89258C9.16992 9.72656 9.30273 9.59375 9.50195 9.59375H10.4648C10.6641 9.59375 10.7969 9.72656 10.8633 9.89258L11.793 13.3125L12.5566 9.92578C12.623 9.72656 12.7559 9.59375 12.9551 9.59375ZM12.125 1.625V5.875H16.375L12.125 1.625Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FileIconWord
